// Cast-Kacheln je Building - solange die Liste noch nicht aus Portal/DB kommt.
//
// Schluessel ist die Building-Id (bid) als String, Wert die Katalog-Schluessel
// aus CAST_APP_CATALOG (helpers/Cast/index.js) in der gewuenschten Reihenfolge.
// Gedacht fuer Apps, die in einem Haus nachweislich gehen - alles andere
// bekommt die Standardliste DEFAULT_CAST_APPS.
//
// Rangfolge beim Aufbau der Kachelseite (siehe cast/init):
//   1. device.castApps          - Geraetedatensatz aus der API (einzelner TV)
//   2. ?apps=... am Menuepunkt  - Cast-Kachel im Hauptmenue des Buildings,
//                                 z.B. url '#cast?apps=youtube,dazn,joyn'
//   3. diese Tabelle            - je Building, im Code
//   4. DEFAULT_CAST_APPS        - fuer alle
//
// Jede Aenderung hier braucht einen neuen Build und ein Deploy - fuer die
// Pflege ohne Deploy ist Weg 2 (Menue-Parameter im Portal) gedacht.
export const CAST_APPS_BY_BUILDING = {
  // Beispiel:
  // '2': ['youtube', 'amazon', 'disney'],
};

export function castAppsForBuilding(buildingId) {
  if (buildingId === null || buildingId === undefined || buildingId === '') return null;
  const list = CAST_APPS_BY_BUILDING[String(buildingId)];
  return Array.isArray(list) && list.length ? list.slice() : null;
}



// WEBPACK FOOTER //
// ./src/helpers/Cast/buildingApps.js